import { useEffect, useState, useMemo, ReactNode } from 'react';
import { Icon, Text, Carousel } from 'components';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useUserStore } from 'store';
import { TEXT_STRING } from '../../../constants';
import { TGlamourImage } from 'types';

type Props = {
  images: TGlamourImage[];
};

function GlamourImage({ images = [] }: Props) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const { isAuthenticated } = useUserStore();

  const processedImages = useMemo(() => {
    const mainImage = images.find((img) => img.isMain);
    const otherImages = images.filter((img) => !img.isMain);

    const allImages = mainImage ? [mainImage, ...otherImages] : otherImages;

    return allImages.map((image, idx) => ({
      ...image,
      idx,
    }));
  }, [images]);

  const thumbChildren: ReactNode = useMemo(
    () =>
      processedImages.map((img, idx) => (
        <img
          key={`glamour-thumb-${idx}`}
          src={img.imageUrl}
          className="object-cover object-top aspect-square"
          height={100}
          alt=""
        />
      )),
    [processedImages],
  );

  useEffect(() => {
    setCurrentIdx(0);
  }, [images]);

  return (
    <div className="mt-22px">
      <Carousel
        selectedMediaIndex={currentIdx}
        thumbsChildren={thumbChildren}
        autoHeight={true}
      >
        {processedImages.map((image, index) => (
          <div key={`glamour-${index}`} className="relative">
            <img
              src={image.imageUrl}
              loading="lazy"
              className="w-full object-contain object-center"
              alt=""
            />
            {!isAuthenticated && (
              <div className="absolute z-[1] inset-0 flex flex-col gap-2 justify-center items-center w-full h-full">
                <Icon icon="lock" />
                <Text
                  textColor="text-white"
                  fontSize={14}
                  className="w-1/2"
                  center
                >
                  {TEXT_STRING.CAST_PAGE.REQUIRE_LOGIN_FOR_GLAMOUR_IMAGE}
                </Text>
              </div>
            )}
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default GlamourImage;
